module.exports = __webpack_public_path__ + "media/images/banner-1-16dfaf83914175ef7f53532203038a96.png";